import React from 'react';
// import photoImg from '../../images/photo.png';
import photoImg from 'images/Paul Ryan.jpg';
import DamienOBrienImg from 'images/DamienOBrien.jpg';
import IsabelImg from 'images/IsabelBourke.jpeg';

export default class AboutUs extends React.Component {

  render(){
    return (
      <section className="about-us section-center">
        <div className="section-center-wrapper">
          <div className="hero-block">
            <h4 className="subTitle">
              {/* Since 2007, Prescription Revision has been helping over a thousand GP trainees to succeed
              in both their CCT and CKT MICGP Examinations. We are passionate about delivering key
              concepts on how to succeed in the MICGP exam. We use a range of different formats
              including podcasts, video and text to teach GP trainees. */}
              About Us
            </h4>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="info-block col-md-3">
                <div className="info-block-inner">
                  <img src={photoImg} alt="About Us" className='aboutImg' />
                  <p>
                    Paul Ryan is both a qualified pharmacist and a GP and has a passion for teaching. He completed a postgraduate certificate in teaching and learning and is currently completing a MD.
                  </p>
                </div>
              </div>
              <div className="info-block col-md-3">
                <div className="info-block-inner">
                  <img src={IsabelImg} alt="About Us" className='aboutImg' />
                  <p>
                    Isabel qualified from UCC School of Medicine in 2024 and is currently working as a NCHD in Cork. She has an interest in psychiatry and neurology. Her pastimes include playing the cello with the Irish Doctor’s orchestra and playing hockey with UCC.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/informations/AboutUs.js